// extracted by mini-css-extract-plugin
export default {"chart":"styles_chart__p1g7a"};